import * as React from 'react';
import {FormEvent, RefObject, useContext, useState} from "react";
import { AppContext } from "../../context/AppContext";
import ChartPerformanceSupplier from "../Chart/ChartPerformanceSupplier";
import { openDatePickerOnKey, Panel } from "./index";
import IconComponent from "../IconComponent";

/**
 * PanelChartPerformance
 * @constructor
 */
export function PanelChartPerformanceSupplier() {
  const {
    useOnDomEvent,
    I18N
  } = useContext(AppContext);

  /**
   * state variables for panel input fields
   */
  const [ from, setFrom ] = useState<string>(""),
    [ to, setTo ] = useState<string>("")

  /**
   * onDomChangeFrom
   */
  const onDomChangeFrom: RefObject<unknown> = useOnDomEvent(
    "change",
    (event: FormEvent<HTMLInputElement>): false | void => from !== event.currentTarget.value && setFrom(event.currentTarget.value)
  );

  /**
   * onDomChangeTo
   */
  const onDomChangeTo: RefObject<unknown> = useOnDomEvent(
    "change",
    (event: FormEvent<HTMLInputElement>): false | void => to !== event.currentTarget.value && setTo(event.currentTarget.value)
  );

  /**
   * callback called by child chart if values are manipulated
   * to update input fields values on two-way data binding
   * @param _from
   * @param _to
   */
  const setValues = (
    _from: string,
    _to: string
  ): void => {
    setFrom(_from);
    setTo(_to);
  };

  return (
    <Panel header={<>
        <IconComponent iconName="chart-simple" />
        { I18N.t('Performance - Lieferanten Schnittstelle') }
      </>} footer={<dia-form>
      <dia-form-line>
        <dia-form-control>
          <i data-icon-before="calendar" data-date-picker-trigger="dia-chart-performance-supplier-from"></i>
          <input
            //@ts-ignore
            ref={ onDomChangeFrom }
            name="dia-chart-performance-supplier-from"
            aria-label={ I18N.t("Zeitraum von") }
            type="text"
            has="date-picker"
            data-date-picker-position="top left"
            data-date-picker-default={ from }
            data-date-picker-range="dia-chart-performance-supplier-to"
            value={ from }
            data-icon
            data-icon-hover
            readOnly
            onKeyDown={ openDatePickerOnKey }
          />
        </dia-form-control>
        <dia-form-control>
          <i data-icon-before="calendar" data-date-picker-trigger="dia-chart-performance-supplier-to"></i>
          <input
            //@ts-ignore
            ref={ onDomChangeTo }
            name="dia-chart-performance-supplier-to"
            aria-label={ I18N.t("Zeitraum bis") }
            type="text"
            has="date-picker"
            data-date-picker-default={ to }
            value={ to }
            data-icon
            data-icon-hover
            data-date-picker-range
            readOnly
            onKeyDown={ openDatePickerOnKey }
          />
        </dia-form-control>
      </dia-form-line>
    </dia-form>
    }>
      <ChartPerformanceSupplier
        from={ from }
        to={ to }
        onSetValues={ setValues }
      ></ChartPerformanceSupplier>
    </Panel>
  );
}
